@if (dataValid()) {
  <section class="gs-icon-list" [id]="viewData().Id" data-cy="gs-icon-list-container">
    <div class="list-header-container">
      <h2 class="list-header" data-cy="gs-icon-list-header">{{ viewData().Header }}</h2>
      <p class="list-subheader" data-cy="gs-icon-list-subheader">{{ viewData().Subheader }}</p>
    </div>

    <ol class="list-bullets-container" data-cy="list-gs-icon-list-bullets">
      @for (bullet of bullets(); track bullet.BulletTitle + "-" + $index) {
        @if (bullet.ShowBullet) {
          <li class="list-bullet" data-cy="item-gs-icon-list-bullet">
            <img class="list-bullet-icon" [src]="bullet.IconPath" [alt]="bullet.IconAltText" />
            <div class="list-bullet-text-container">
              <h3 class="list-bullet-title">{{ bullet.BulletTitle }}</h3>
              <p class="list-bullet-text">{{ bullet.BulletText }}</p>
            </div>
          </li>
        }
      }
    </ol>
  </section>
}
